// Shared bits for the UC CDR tabs.
export const DIR_TONE = {
  inbound: "bg-sky-100 text-sky-800", outbound: "bg-indigo-100 text-indigo-800",
  internal: "bg-slate-100 text-slate-600",
};
export const STATUS_TONE = {
  open: "bg-sky-100 text-sky-800", closed: "bg-slate-200 text-slate-700",
  synced: "bg-emerald-100 text-emerald-800",
};

export const mins = (seconds) => `${Math.round((seconds || 0) / 60).toLocaleString()} min`;
export const clock = (iso) => (iso ? iso.replace("T", " ").replace("Z", "").slice(0, 19) : "—");
export const money = (amount, currency) =>
  `${(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency || ""}`.trim();

// Display only — the server owns every conversion that touches a bill.
export const inZone = (iso, tz) => {
  if (!iso) return "—";
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return iso;
  const p = new Intl.DateTimeFormat("en-CA", {
    timeZone: tz || "UTC", year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
  }).formatToParts(at).reduce((acc, part) => ({ ...acc, [part.type]: part.value }), {});
  return `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}:${p.second}`;
};

export const zoneAbbrev = (tz, iso) => {
  try {
    return new Intl.DateTimeFormat("en-US", { timeZone: tz || "UTC", timeZoneName: "short" })
      .formatToParts(iso ? new Date(iso) : new Date())
      .find((part) => part.type === "timeZoneName")?.value || "";
  } catch {
    return "";
  }
};

export function Pill({ children, tone = "bg-slate-100 text-slate-700" }) {
  return <span className={`inline-flex rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${tone}`}>{children}</span>;
}

export function Stat({ label, value, hint, tone, testid }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white px-4 py-3" data-testid={testid}>
      <div className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">{label}</div>
      <div className={`mt-0.5 text-xl font-semibold ${tone || "text-slate-800"}`}>{value}</div>
      {hint && <div className="text-[11px] text-slate-400">{hint}</div>}
    </div>
  );
}
